import { DEFAULT_VALUE } from "@/config";
import { PAYMENT_TYPE } from "@/meta/purchase/payment";
import { isNil } from "lodash-es";
import { RECONCILIATION_TYPE } from "@/meta/purchase/receipt";
import type { ProjectVo } from "@zhihaoscm/entity";
import { PURCHASE_TYPE } from "@zhihaoscm/meta";

/**
 * 获取付款单位，收款单位身份
 * @upOrDown: 上 ： 1  下 ： 0
 * */
export const getIdentityByPayType = (paymentType: number = 10, upOrDown: number, isOnly: boolean = false): string => {
    if (paymentType === 10) return DEFAULT_VALUE;
    let payType: string;
    if (isOnly) {
        payType = RECONCILIATION_TYPE.getIntroByCode(paymentType);
    } else {
        payType = PAYMENT_TYPE.getIntroByCode(paymentType);
    }
    const identityArr = payType.split("-");
    identityArr.reverse();
    return identityArr[upOrDown];
};

/**格式化金额，数量大数据 */
export const formatAmountData = (str?: number | string): string => {
    if (isNil(str)) return DEFAULT_VALUE;
    return String(str).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**获取行内值, 如果没有则返回default-value */
export const getInlineValue = (value?: unknown) => {
    if (value === "") {
        return DEFAULT_VALUE;
    }
    return value ?? DEFAULT_VALUE;
};

/**根据采购类型获取付款类型options */
export const getPaymentTypeOptions = (purType: number) => {
    const options = PAYMENT_TYPE.options;
    // 直采
    if (PURCHASE_TYPE.DIRECT.match(purType)) {
        return options.filter(item => item.value === PAYMENT_TYPE.BOTTOM_TO_TOP.code);
    }
    // 联合采购
    if (PURCHASE_TYPE.JOINT.match(purType)) {
        return options.filter(item => item.value !== PAYMENT_TYPE.BOTTOM_TO_TOP.code);
    }
    return options;
};

/**
 * 获取后端新增单据时需要的customerId字段
 * @param projectVo 项目信息
 * @param currentBuyerId 联合采购是选中的当前用户buyerId
 * @param paymentType 付款类型
 * @param Reconciliation 是否是对账单, 对账单的枚举与其它单据不同
 * @return businessCustomer 后端需要的customerId
 */
export const getBusinessCustomerId = (
    paymentType: number,
    projectVo?: ProjectVo,
    currentBuyerId?: number,
    Reconciliation?: boolean
) => {
    const _currentBuyerId =
        currentBuyerId ?? (projectVo?.projectExtends.length === 1 ? projectVo?.projectExtends[0].buyerId : undefined);
    if (Reconciliation) {
        switch (paymentType) {
            case RECONCILIATION_TYPE.DOWNSTREAM_UPSTREAM.code:
                return projectVo?.projectExtends[0].buyerId;
            case RECONCILIATION_TYPE.DOWNSTREAM_MIDSTREAM.code:
                return _currentBuyerId;
            case RECONCILIATION_TYPE.MIDSTREAM_UPSTREAM.code:
                return projectVo?.project.supplyChainId;
        }
    } else {
        switch (paymentType) {
            case PAYMENT_TYPE.BOTTOM_TO_TOP.code:
                return projectVo?.projectExtends[0].buyerId;
            case PAYMENT_TYPE.BOTTOM_TO_MEDIUM.code:
                return _currentBuyerId;
            case PAYMENT_TYPE.MEDIUM_TO_TOP.code:
                return projectVo?.project.supplyChainId;
        }
    }
};
